import checkIsKitPro from './checkIsKitPro';
export default function getKitLabel(kit, showFullLabel) {
    if (checkIsKitPro(kit))
        return showFullLabel ? 'PRO Gut health test' : 'PRO Gut test';
    if (kit.sampling_type === 'stool')
        return showFullLabel ? 'Gut health test' : 'Gut test';
    return showFullLabel ? 'Vaginal health test' : 'Vaginal test';
}
//# sourceMappingURL=getKitLabel.js.map